import React, { useState, useImperativeHandle, forwardRef, Ref } from "react";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { translationService } from "../../services/translation/TranslationService";

export interface DataGridSelectAllMenuProps {
  selectPage: () => void;
  selectAll: () => void;
  deselectAll: () => void;
}

export interface DataGridSelectAllMenuRef {
  openMenu: (currentTarget: any) => void;
}

export default forwardRef((props: DataGridSelectAllMenuProps, ref: Ref<DataGridSelectAllMenuRef>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const selectPageClick = () => {
    setAnchorEl(null);
    props.selectPage();
  };

  const selectAllClick = () => {
    setAnchorEl(null);
    props.selectAll();
  };

  const deselectAllClick = () => {
    setAnchorEl(null);
    props.deselectAll();
  };

  useImperativeHandle(ref, () => ({
    openMenu: (currentTarget) => setAnchorEl(currentTarget)
  }));

  return (
    <Menu
      id="datagrid-select-all-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      MenuListProps={{ 'aria-labelledby': 'basic-button', }}
    >
      <MenuItem onClick={selectPageClick}>{translationService.translate("general.data-grid.select-all-menu.select-page")}</MenuItem>
      <MenuItem onClick={selectAllClick} divider>{translationService.translate("general.data-grid.select-all-menu.select-all")}</MenuItem>
      <MenuItem onClick={deselectAllClick}>{translationService.translate("general.data-grid.select-all-menu.deselect-all")}</MenuItem>
    </Menu>
  );
});
